/*jshint esversion: 9 */
/*jshint sub:true*/
// import { mapGetters, mapActions } from 'vuex';
import StandardSwitch from '@/components/StandardComponents/StandardSwitch.component.vue';
export const SwitchMixin = {
  components: {
    StandardSwitch,
  },
  data: () => ({
  }),
  computed: {

  },
  methods: {

  }
};
